import { render, staticRenderFns } from "./common-patient.vue?vue&type=template&id=06761d5c&scoped=true&"
import script from "./common-patient.vue?vue&type=script&lang=ts&"
export * from "./common-patient.vue?vue&type=script&lang=ts&"
import style0 from "./common-patient.vue?vue&type=style&index=0&id=06761d5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06761d5c",
  null
  
)

export default component.exports